import request from 'utils/request'

// 分页查询得分等级风险
export const page = data => request().post('grading/page', data)
// 新增得分等级风险
export const addTable = data => request().post('grading/add', data)
// 修改得分等级风险
export const update = data => request().post('grading/update', data)
// 删除得分等级风险
export const remove = id => request().get(`grading/delete/${id}`)
// 删除得分等级风险
export const info = id => request().get(`grading/info/${id}`)
// 查询对应的名字
export const getUserName = id => request().get(`grading/getUserName/${id}`)